const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
// src/services/liveService.js
const BASE_URL = API_BASE_URL;

// ✅ Get headers with token
const getAuthHeaders = () => {
  const token =
    sessionStorage.getItem("accessToken") ||
    localStorage.getItem("accessToken");
  if (!token)
    throw new Error("Authentication token is missing. Please log in again.");
  return {
    "Content-Type": "application/json",
    token,
  };
};

// ✅ Handle API response with errors
const handleResponse = async (res) => {
  const data = await res.json();
  if (!res.ok || !data.success) {
    throw new Error(data.message || "API request failed.");
  }
  return data.result;
};

export const initLiveStream = async ({
  recording_enabled = false,
  stream_type = "live",
  distroy_previous_stream = false,
  navigation_source = "default",
} = {}) => {
  const res = await fetch(`${BASE_URL}/live/init`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({
      recording_enabled,
      stream_type,
      distroy_previous_stream,
      navigation_source,
    }),
  });
  return handleResponse(res);
};

export const saveMetadata = async ({ stream_id, title, category, tags }) => {
  const res = await fetch(`${BASE_URL}/live/metadata`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ stream_id, title, category, tags }),
  });
  return handleResponse(res);
};

export const setPreview = async (stream_id) => {
  const res = await fetch(`${BASE_URL}/live/preview`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ stream_id }),
  });
  return handleResponse(res);
};

export const startLive = async (stream_id) => {
  const res = await fetch(`${BASE_URL}/live/start`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ stream_id }),
  });
  return handleResponse(res);
};

export const endLive = async (stream_id) => {
  const res = await fetch(`${BASE_URL}/live/end`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ stream_id }),
  });
  return handleResponse(res);
};

export const getStreamStatus = async (stream_id) => {
  const res = await fetch(`${BASE_URL}/live/status/${stream_id}`, {
    method: "GET",
    headers: getAuthHeaders(),
  });
  return handleResponse(res);
};
